import "unfetch/polyfill";

export default function findCategories(apiUrl, apiKey) {
  return new Promise(function(resolve, reject) {
    fetch(apiUrl + "category?apiKey=" + apiKey)
      .then(r => r.json())
      .then(data => {
        resolve(data);
      })
      .catch(reason => {
        reject(reason);
      });
  });
}
